import React from "react";
import { CREDENTIALS } from "../../data/content";

const Credentials = () => (
  <section aria-label="Supported credentials" className="relative border-y border-white/10 bg-ink-900/40 py-8">
    <p className="container mb-6 text-center text-xs font-medium uppercase tracking-[0.2em] text-ink-400">
      Every credential, one platform
    </p>
    <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
      <ul className="flex w-max animate-marquee gap-4 hover:[animation-play-state:paused]">
        {[...CREDENTIALS, ...CREDENTIALS].map(({ label, icon: Icon }, i) => (
          <li
            key={`${label}-${i}`}
            aria-hidden={i >= CREDENTIALS.length ? "true" : undefined}
            className="flex items-center gap-2.5 whitespace-nowrap rounded-full border border-white/10 bg-white/[0.03] px-5 py-2.5 text-sm font-medium text-ink-200"
          >
            <Icon className="h-4 w-4 text-brand-500" />
            {label}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Credentials;
